
  import AppMast from "@/components/AppMast.vue"; // @ is an alias to /src

  export default {
    name: "Home",
    components: {
      AppMast
    }
  }
